import React from 'react';
import ModalFrame from '../../dashboard/components/product_item_components/ModalFrame';
import '../../dashboard/Dashboard.css';
import { BUSINESS_TYPE_OPTIONS, businessTypeById } from '../../../types/BusinessType';
import './BusinessTypeField.css';

export default function BusinessTypeField({ typeId, onTypeIdChange, disabled }) {
  const [isOpen, setIsOpen] = React.useState(false);
  const selected = businessTypeById(typeId);

  return (
    <section className="shop-create-section">
      <div className="shop-create-label">Тип бизнеса <b style={{ color: 'red' }}>*</b></div>
      <button
        type="button"
        className="shop-type-button"
        onClick={() => setIsOpen(true)}
        disabled={disabled}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
      >
        <span className="shop-type-name">{selected.name}</span>
      </button>

      {isOpen ? (
        <ModalFrame title="Тип бизнеса" onClose={() => setIsOpen(false)}>
          <div className="main-page-modalList" role="listbox" aria-label="Тип бизнеса">
            {BUSINESS_TYPE_OPTIONS.map((option) => {
              const selectedOption = option.id === selected.id;
              return (
                <button
                  key={option.id}
                  type="button"
                  role="option"
                  aria-selected={selectedOption}
                  className={
                    selectedOption
                      ? 'main-page-modalItem main-page-modalItemSelected shop-type-option'
                      : 'main-page-modalItem shop-type-option'
                  }
                  onClick={() => {
                    onTypeIdChange?.(option.id);
                    setIsOpen(false);
                  }}
                >
                  <span className="shop-type-name">{option.name}</span>
                  <span className="shop-type-help">{option.help}</span>
                </button>
              );
            })}
          </div>
        </ModalFrame>
      ) : null}
    </section>
  );
}
